/* =========================================================
   OVERTOP / Urban-Haul — Sticky Mobile Buy Bar  v7 (Horizon port)
   Standalone bottom bar (#otStickyAtcBar), built in <body> so it
   survives Horizon's section morphs. Re-queries live form / price /
   radio nodes on every sync (Horizon replaces those nodes on variant
   change via the Section Rendering API).

   - Colour swatch chips (true brand shades) proxy clicks into the real
     <variant-picker> radios.
   - Fused CTA: red price pill + dark ADD TO CART read as ONE click.
   - Live price + savings %, smart reveal, breathing glow + sheen.
   - Hides Horizon's native <sticky-add-to-cart> (no duplicate bar).
   ========================================================= */

(function () {
  'use strict';

  var VERSION = '7.0.0-horizon';
  window.__OT_STICKY_BUYBAR_VERSION = VERSION;

  /* ============ Brand shades ============ */
  var COLOR_MAP = {
    'black': '#1c1d1d', 'grey': '#8b8d8e', 'gray': '#8b8d8e',
    'brown': '#6f4a2f', 'tan': '#b08d57', 'camel': '#c19a6b',
    'navy': '#1f2a44', 'blue': '#2f4b7c', 'green': '#3a5a40',
    'red': '#b3261e', 'beige': '#d9c7a7', 'white': '#f2f2f2',
    'maroon': '#5e1f1f', 'olive': '#5b5a2f', 'cream': '#f5ecd9',
    'pink': '#e8a0b4'
  };

  var stylesInjected = false;
  var built = false;
  var initRetries = 0;
  var chipSignature = '';

  /* ---------- helpers ---------- */
  function isProductPage() {
    return !!document.querySelector('main[data-template*="product"]');
  }
  function cssEsc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }
  function digits(t) {
    var d = (t || '').replace(/[^\d]/g, '');
    return d ? parseInt(d, 10) : null;
  }
  function isCssColor(c) {
    if (!c) return false;
    var s = new Option().style; s.color = ''; s.color = c; return s.color !== '';
  }
  function resolveColor(name) {
    var key = (name || '').trim().toLowerCase();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    var parts = key.split(/[\s\/_-]+/);
    for (var i = parts.length - 1; i >= 0; i--) if (COLOR_MAP[parts[i]]) return COLOR_MAP[parts[i]];
    if (isCssColor(key)) return key;
    return '#cccccc';
  }

  /* ---------- live element getters (morph-safe) ---------- */
  function getRealAtc() {
    var btns = document.querySelectorAll(
      'add-to-cart-component button[name="add"], product-form-component button[name="add"]'
    );
    for (var i = 0; i < btns.length; i++) {
      if (!btns[i].closest('.quick-add, quick-add-component, product-card, .product-card, .product-recommendations, .card-gallery')) {
        return btns[i];
      }
    }
    return btns[0] || null;
  }
  function getMainSection() {
    var atc = getRealAtc();
    var sec = atc && atc.closest('product-information-component, [id^="shopify-section"], section');
    return sec || document.querySelector('product-information-component') || document;
  }
  function getPriceContainer() {
    var sec = getMainSection();
    return sec.querySelector('product-price [ref="priceContainer"]') || sec.querySelector('product-price');
  }
  function getColorFieldset() {
    var sec = getMainSection();
    var fss = sec.querySelectorAll('variant-picker fieldset.variant-option, fieldset.variant-option');
    for (var i = 0; i < fss.length; i++) {
      var lg = fss[i].querySelector('legend');
      if (lg && /colou?r/.test(lg.textContent.trim().toLowerCase())) return fss[i];
    }
    return null;
  }
  function colorRadios() {
    var fs = getColorFieldset();
    return fs ? Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')) : [];
  }
  function drawerOpen() {
    return !!document.querySelector('cart-drawer-component dialog[open]');
  }

  /* ---------- styles ---------- */
  function injectStyles() {
    if (stylesInjected) return;
    stylesInjected = true;

    if (!document.querySelector('link[data-ot-anton]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Anton&display=swap';
      l.setAttribute('data-ot-anton', '1');
      document.head.appendChild(l);
    }

    var css = [
      /* hide Horizon's native sticky bar — we replace it entirely */
      'sticky-add-to-cart{display:none !important;}',

      '#otStickyAtcBar{position:fixed;left:0;right:0;bottom:0;z-index:2147482000;transform:translateY(120%);transition:transform .26s cubic-bezier(.16,1,.3,1);background:rgba(255,255,255,.97);border-top:1px solid rgba(0,0,0,.07);border-radius:18px 18px 0 0;box-shadow:0 -10px 34px rgba(0,0,0,.16);padding:10px 14px calc(10px + env(safe-area-inset-bottom,0px));font-family:inherit;}',
      '#otStickyAtcBar.ot-show{transform:translateY(0);}',
      '@media (min-width:769px){#otStickyAtcBar{display:none !important;}}',

      /* swatch row */
      '#otStickyAtcBar .ot-swrow{display:flex;gap:8px;align-items:center;overflow-x:auto;-webkit-overflow-scrolling:touch;padding:2px 2px 10px;margin-bottom:2px;scrollbar-width:none;}',
      '#otStickyAtcBar .ot-swrow::-webkit-scrollbar{display:none;}',
      '#otStickyAtcBar .ot-swrow:empty{display:none;}',
      '#otStickyAtcBar .ot-sw{flex:0 0 auto;display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 14px;border-radius:999px;border:1.5px solid rgba(0,0,0,.14);background:#fff;color:#1c1d1d;font-weight:700;font-size:13.5px;letter-spacing:.2px;text-transform:capitalize;white-space:nowrap;cursor:pointer;transition:border-color .14s,box-shadow .14s,transform .12s,background .14s;}',
      '#otStickyAtcBar .ot-sw .ot-dot{width:16px;height:16px;border-radius:999px;background-size:cover;background-position:center;box-shadow:inset 0 0 0 1px rgba(0,0,0,.22);flex:0 0 auto;}',
      '#otStickyAtcBar .ot-sw[aria-pressed="true"]{border-color:#e10600;box-shadow:0 0 0 1px #e10600;transform:translateY(-1px);}',
      '#otStickyAtcBar .ot-sw[aria-pressed="true"] .ot-dot{box-shadow:inset 0 0 0 1px rgba(0,0,0,.22),0 0 0 2px #fff,0 0 0 3.5px #e10600;}',
      '#otStickyAtcBar .ot-sw.is-soldout{opacity:.4;text-decoration:line-through;}',

      /* action row — fused CTA */
      '#otStickyAtcBar .ot-row{display:flex;}',
      '#otStickyAtcBar .ot-cta-wrap{position:relative;flex:1 1 auto;display:flex;}',
      '#otStickyAtcBar .ot-cta-glow{position:absolute;inset:-2px;border-radius:16px;z-index:0;pointer-events:none;box-shadow:0 0 0 2px rgba(225,6,0,.28),0 4px 18px rgba(225,6,0,.42);opacity:.45;animation:otAtcGlow 2.6s ease-in-out infinite;}',
      '#otStickyAtcBar .ot-cta-wrap.ot-disabled .ot-cta-glow{display:none;}',
      '#otStickyAtcBar .ot-cta{position:relative;z-index:1;flex:1 1 auto;display:flex;align-items:stretch;border-radius:14px;overflow:hidden;cursor:pointer;transition:transform .08s ease,opacity .15s ease;}',
      '#otStickyAtcBar .ot-cta:active{transform:scale(.985);}',
      '#otStickyAtcBar .ot-cta::after{content:"";position:absolute;inset:0;pointer-events:none;z-index:3;background:linear-gradient(105deg,transparent 36%,rgba(255,255,255,.55) 50%,transparent 64%);transform:translateX(-130%);animation:otAtcSheen 3s ease-in-out 1s infinite;}',
      '#otStickyAtcBar .ot-cta-wrap.ot-disabled .ot-cta::after{display:none;}',

      /* price segment */
      '#otStickyAtcBar .ot-price{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;line-height:1;flex:0 0 auto;text-align:center;background:#e10600;color:#fff;padding:7px 16px;}',
      '#otStickyAtcBar .ot-now{font-family:"Anton",sans-serif;font-weight:400;font-size:23px;letter-spacing:.5px;line-height:1;color:#fff;}',
      '#otStickyAtcBar .ot-meta{display:flex;align-items:center;justify-content:center;gap:8px;line-height:1;}',
      '#otStickyAtcBar .ot-old{font-size:12px;color:rgba(255,255,255,.72);text-decoration:line-through;line-height:1;}',
      '#otStickyAtcBar .ot-save{font-size:11px;font-weight:800;color:#e10600;background:#fff;padding:2px 7px;border-radius:6px;letter-spacing:.3px;line-height:1.2;}',

      /* action segment */
      '#otStickyAtcBar .ot-atc{position:relative;flex:1 1 auto;min-height:50px;display:inline-flex;align-items:center;justify-content:center;gap:10px;border:0;cursor:pointer;font-weight:900;font-size:15.5px;letter-spacing:.4px;text-transform:uppercase;color:#fff;background:#1c1d1d;}',
      '#otStickyAtcBar .ot-atc svg{width:18px;height:18px;flex:0 0 auto;}',
      '#otStickyAtcBar .ot-cta-wrap.ot-disabled .ot-cta{opacity:.55;cursor:not-allowed;}',
      '#otStickyAtcBar .ot-cta-wrap.ot-disabled .ot-atc{background:#9b9b9b;}',

      '@keyframes otAtcGlow{0%,100%{opacity:.35;}50%{opacity:.95;}}',
      '@keyframes otAtcSheen{0%{transform:translateX(-130%);}20%{transform:translateX(130%);}100%{transform:translateX(130%);}}',
      '@media (prefers-reduced-motion:reduce){#otStickyAtcBar,#otStickyAtcBar .ot-sw{transition:none;}#otStickyAtcBar .ot-cta-glow{animation:none;opacity:.5;}#otStickyAtcBar .ot-cta::after{animation:none;display:none;}}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'ot-sticky-buybar-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  /* ---------- build (once) ---------- */
  var bar, swRow, nowEl, oldEl, saveEl, metaEl, btn, btnLabel, ctaWrap;

  function build() {
    if (built) return;
    built = true;

    bar = document.createElement('div');
    bar.id = 'otStickyAtcBar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick buy');
    bar.setAttribute('aria-hidden', 'true');

    swRow = document.createElement('div'); swRow.className = 'ot-swrow';

    var row = document.createElement('div'); row.className = 'ot-row';
    var priceWrap = document.createElement('div'); priceWrap.className = 'ot-price';
    nowEl = document.createElement('span'); nowEl.className = 'ot-now';
    metaEl = document.createElement('span'); metaEl.className = 'ot-meta';
    oldEl = document.createElement('span'); oldEl.className = 'ot-old';
    saveEl = document.createElement('span'); saveEl.className = 'ot-save';
    metaEl.appendChild(oldEl); metaEl.appendChild(saveEl);
    priceWrap.appendChild(nowEl); priceWrap.appendChild(metaEl);

    btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'ot-atc';
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><span class="ot-atc-label">Add to cart</span>';
    btnLabel = btn.querySelector('.ot-atc-label');

    ctaWrap = document.createElement('div'); ctaWrap.className = 'ot-cta-wrap';
    var glow = document.createElement('span'); glow.className = 'ot-cta-glow'; glow.setAttribute('aria-hidden', 'true');
    var cta = document.createElement('div'); cta.className = 'ot-cta'; cta.setAttribute('aria-label', 'Add to cart');
    cta.appendChild(priceWrap); cta.appendChild(btn);
    ctaWrap.appendChild(glow); ctaWrap.appendChild(cta);
    row.appendChild(ctaWrap);

    bar.appendChild(swRow); bar.appendChild(row);
    document.body.appendChild(bar);

    /* ONE handler: click on price OR button fires the real cart add once */
    cta.addEventListener('click', function () {
      if (btn.disabled) return;
      var real = getRealAtc();
      if (real) real.click();
    });
  }

  /* ---------- chips ---------- */
  function buildChips() {
    var radios = colorRadios();
    var sig = radios.map(function (r) { return r.value; }).join('|');
    if (sig === chipSignature && swRow.children.length) return; // unchanged
    chipSignature = sig;
    swRow.innerHTML = '';
    radios.forEach(function (input) {
      var chip = document.createElement('button');
      chip.type = 'button'; chip.className = 'ot-sw';
      chip.setAttribute('data-value', input.value || '');
      chip.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      chip.setAttribute('aria-label', input.value || '');
      var dot = document.createElement('span'); dot.className = 'ot-dot';
      dot.style.background = resolveColor(input.value);
      var name = document.createElement('span'); name.textContent = input.value;
      chip.appendChild(dot); chip.appendChild(name);
      chip.addEventListener('click', function () {
        var fs = getColorFieldset();
        var live = fs && fs.querySelector('input[type="radio"][value="' + cssEsc(input.value) + '"]');
        if (live && !live.checked) live.click();
      });
      swRow.appendChild(chip);
    });
  }

  /* ---------- sync price / state / active chip ---------- */
  function realAtcText() {
    var real = getRealAtc();
    if (!real) return 'Add to cart';
    var t = real.querySelector('.add-to-cart-text, [data-add-to-cart-text]');
    var txt = (t && t.textContent.trim()) || real.textContent.trim();
    return txt || 'Add to cart';
  }
  function readPrice() {
    var pc = getPriceContainer();
    if (!pc) return { now: '', compare: '', pct: 0 };
    var nowEl2 = pc.querySelector('.price__sale:not(.price__hidden) .price-item--sale') ||
                 pc.querySelector('.price__regular:not(.price__hidden) .price') ||
                 pc.querySelector('.price-item--sale') ||
                 pc.querySelector('.price');
    var cmpEl = pc.querySelector('.price__sale:not(.price__hidden) .compare-at-price') ||
                pc.querySelector('.compare-at-price');
    var now = nowEl2 ? nowEl2.textContent.replace(/\s+/g, ' ').trim() : '';
    var compare = '', pct = 0;
    if (cmpEl) {
      var c = digits(cmpEl.textContent), n = digits(now);
      if (c && n && c > n) { compare = cmpEl.textContent.replace(/\s+/g, ' ').trim(); pct = Math.round((c - n) / c * 100); }
    }
    return { now: now, compare: compare, pct: pct };
  }
  function sync() {
    if (!built) return;
    buildChips();

    var p = readPrice();
    // Drop a trailing ".00" (zero paisa) for display — real paisa like ".50" stays.
    nowEl.textContent = String(p.now).replace(/\.00(?!\d)/g, '');
    if (p.compare) {
      oldEl.textContent = String(p.compare).replace(/\.00(?!\d)/g, '');
      saveEl.textContent = '−' + p.pct + '%';
      metaEl.style.display = '';
    } else {
      metaEl.style.display = 'none';
    }

    var real = getRealAtc();
    btnLabel.textContent = realAtcText();
    var disabled = !real || real.hasAttribute('disabled') || real.disabled ||
                   real.getAttribute('aria-disabled') === 'true';
    btn.disabled = disabled;
    ctaWrap.classList.toggle('ot-disabled', disabled);

    var radios = colorRadios();
    var checkedVal = '';
    radios.forEach(function (r) { if (r.checked) checkedVal = r.value; });
    Array.prototype.forEach.call(swRow.querySelectorAll('.ot-sw'), function (chip) {
      var v = chip.getAttribute('data-value');
      chip.setAttribute('aria-pressed', v === checkedVal ? 'true' : 'false');
      var live = radios.filter(function (r) { return r.value === v; })[0];
      var avail = live && live.getAttribute('data-option-available') !== 'false' && !live.disabled;
      chip.classList.toggle('is-soldout', !!live && !avail);
    });
  }
  function syncSoon() {
    requestAnimationFrame(function () { requestAnimationFrame(sync); });
  }

  /* ---------- smart reveal (scroll-based, morph-safe) ---------- */
  var revealQueued = false;
  function evalReveal() {
    revealQueued = false;
    if (!built) return;
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    if (!mobile || drawerOpen()) { hide(); return; }
    var real = getRealAtc();
    if (!real) { hide(); return; }
    var r = real.getBoundingClientRect();
    // show once the real ATC has scrolled out of view (above or below the viewport)
    var visible = r.bottom > 0 && r.top < window.innerHeight;
    if (visible) hide(); else show();
  }
  function queueReveal() {
    if (revealQueued) return;
    revealQueued = true;
    requestAnimationFrame(evalReveal);
  }
  function show() { bar.classList.add('ot-show'); bar.setAttribute('aria-hidden', 'false'); }
  function hide() { bar.classList.remove('ot-show'); bar.setAttribute('aria-hidden', 'true'); }

  /* ---------- wiring ---------- */
  var wired = false;
  function wire() {
    if (wired) return;
    wired = true;
    window.addEventListener('scroll', queueReveal, { passive: true });
    window.addEventListener('resize', function () { queueReveal(); syncSoon(); }, { passive: true });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'INPUT' && e.target.type === 'radio' &&
          e.target.closest && e.target.closest('variant-picker')) syncSoon();
    }, true);
    document.addEventListener('variant:update', syncSoon);
    document.addEventListener('variant:selected', syncSoon);
    document.addEventListener('cart:update', function () { syncSoon(); queueReveal(); });

    document.addEventListener('dialog:open', queueReveal);
    document.addEventListener('dialog:close', queueReveal);

    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { init(); syncSoon(); queueReveal(); }, 60);
    });
  }

  /* ---------- init ---------- */
  function init() {
    if (!isProductPage()) return;
    var picker = document.querySelector('variant-picker[ref="mainVariantPicker"]') || document.querySelector('variant-picker');
    var atc = getRealAtc();
    if (!atc || !picker) {
      if (initRetries++ < 40) setTimeout(init, 200);
      return;
    }
    initRetries = 0;
    injectStyles();
    build();
    sync();
    queueReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); wire(); });
  } else {
    init(); wire();
  }
})();
